
const BASE_URL = 'https://api.coinnexs.com/api';

export interface KycStatusResponse {
    success: boolean;
    status: 'NOT_SUBMITTED' | 'PENDING' | 'APPROVED' | 'REJECTED';
    documentType?: string;
    submittedAt?: string;
    message?: string;
}

export interface KycDetailResponse {
    success?: boolean;
    url?: string;
    data?: {
        id: string;
        status: string;
        documentType: string;
        documentKey: string;
        submittedAt: string;
    };
    message?: string;
}

export interface UploadResponse {
    success: boolean;
    key: string;
    message?: string;
}

export interface KycSubmitData {
    document_type: string;
    btc_address: string;
    file_key: string;
}

export interface KycSubmitResponse {
    success: boolean;
    kyc_id?: string;
    status?: string;
    message?: string;
}

export interface FileViewResponse {
    success: boolean;
    url: string;
    message?: string;
}

class KycService {
    private async request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
        const token = localStorage.getItem('coinnexs_token');
        const headers: Record<string, string> = {
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
            ...((options.body instanceof FormData) ? {} : { 'Content-Type': 'application/json' }),
        };

        try {
            const response = await fetch(`${BASE_URL}${endpoint}`, {
                ...options,
                headers: {
                    ...headers,
                    ...(options.headers as Record<string, string>),
                },
            });

            const data = await response.json();
            return data as T;
        } catch (error) {
            console.error(`KYC API Error (${endpoint}):`, error);
            return {
                success: false,
                message: 'Network error. Please try again later.',
            } as unknown as T;
        }
    }

    async getKycStatus(): Promise<KycStatusResponse> {
        return this.request<KycStatusResponse>('/kyc/status');
    }

    async getMyKyc(): Promise<KycDetailResponse> {
        return this.request<KycDetailResponse>('/kyc/me');
    }

    async uploadDocument(file: File): Promise<UploadResponse> {
        const formData = new FormData();
        formData.append('file', file);
        return this.request<UploadResponse>('/upload', {
            method: 'POST',
            body: formData,
        });
    }

    async submitKyc(data: KycSubmitData): Promise<KycSubmitResponse> {
        return this.request<KycSubmitResponse>('/kyc/submit', {
            method: 'POST',
            body: JSON.stringify(data),
        });
    }

    async getFilePreview(key: string): Promise<FileViewResponse> {
        return this.request<FileViewResponse>(`/files/view?key=${encodeURIComponent(key)}`);
    }
}

export const kycService = new KycService();
